module.exports = __webpack_public_path__ + "img/home_live_market.0fafca0.png";